import React from 'react'
import {Tooltip} from 'recharts'
import {alpha, useTheme} from '@mui/material/styles'

const CustomContent = ({active, payload, label, formatter, theme}) => {
    if (!active || !payload?.length) return null

    const palette = theme.palette

    return (
        <div
            style={{
                borderRadius: 12,
                border: `1px solid ${alpha(palette.divider, 0.5)}`,
                boxShadow:
                    palette.mode === 'dark'
                        ? '0 12px 28px rgba(15, 23, 42, 0.55)'
                        : '0 12px 28px rgba(15, 23, 42, 0.18)',
                backgroundColor: palette.background.paper,
                overflow: 'hidden',
                maxWidth: 280,
            }}>
            {/* Sticky label */}
            <div
                style={{
                    padding: '10px 14px 6px',
                    fontWeight: 600,
                    fontSize: 13,
                    borderBottom: `1px solid ${alpha(palette.divider, 0.3)}`,
                    position: 'sticky',
                    top: 0,
                    backgroundColor: palette.background.paper,
                    zIndex: 1,
                }}>
                {label}
            </div>

            {/* Scrollable items */}
            <div style={{maxHeight: 220, overflowY: 'auto', padding: '6px 14px 10px'}}>
                {payload.map((entry, i) => {
                    let displayValue = entry.value
                    let displayName = entry.name
                    if (formatter) {
                        const result = formatter(entry.value, entry.name, entry, i)
                        if (Array.isArray(result)) {
                            displayValue = result[0]
                            displayName = result[1]
                        }
                    }
                    return (
                        <div
                            key={i}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                fontSize: 12,
                                padding: '3px 0',
                                color: palette.text.primary,
                            }}>
                            <span
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: entry.color,
                                    flexShrink: 0,
                                }}
                            />
                            <span style={{flex: 1, opacity: 0.8}}>{displayName}</span>
                            <span style={{fontWeight: 600}}>{displayValue}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const DashboardChartTooltip = React.memo(({cursor, formatter, ...props}) => {
    const theme = useTheme()
    const palette = theme.palette

    const defaultCursor = {
        strokeDasharray: '4 4',
        stroke: alpha(palette.text.secondary, 0.4),
    }

    let mergedCursor = defaultCursor
    if (cursor === false) {
        mergedCursor = false
    } else if (cursor && typeof cursor === 'object') {
        mergedCursor = {...defaultCursor, ...cursor}
    }

    return (
        <Tooltip
            cursor={mergedCursor}
            wrapperStyle={{outline: 'none', zIndex: 1300}}
            content={<CustomContent formatter={formatter} theme={theme} />}
            {...props}
        />
    )
})

export default DashboardChartTooltip
